import axiosInstance from '../../../../common/axios.service';
import {ADD_RACK, UPDATE_RACK} from './racks.type';
import type FILTERS from '../../../../common/filters.type';

const racksList = (values: {station_id?: number[]; filters?: FILTERS}) => {
  return axiosInstance
    .post('rack/list', {station_id: values.station_id}, {params: values.filters})
    .then((response) => {
      return response;
    });
};

const addRack = (values: ADD_RACK) => {
  return axiosInstance.post('rack', values).then((response) => {
    return response;
  });
};

const updateRack = (values: {id: number; payload: UPDATE_RACK}) => {
  return axiosInstance.put(`rack/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const racksServices = {
  racksList,
  addRack,
  updateRack,
};

export default racksServices;
